export enum MonthCalendarDayType {
  DAY_OFF = 'dayOff',
  BUSY = 'busy',
  NOT_IN_CURRENT_MONTH = 'notInCurrentMonth',
  WORK_DAY = 'workDay',
  OLD_DAY = 'oldDay',
  VACATION = 'vacation',
  SICK_LEAVE = 'sickLeave',
  ADMINISTRATIVE = 'administrative',
}
